import { IsNotEmpty, IsString } from 'class-validator';

export class DetailNodeToSignDto {
  @IsNotEmpty()
  @IsString()
  signature: string;

  @IsNotEmpty()
  @IsString()
  hash: string;
}
